module.exports = __webpack_public_path__ + "img/92166.bd02127b.svg";